module.exports = __webpack_public_path__ + "static/media/recs-card-bg.40e0ff38.png";